import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { toBase64 } from "../../functions/base64";
import { useProject } from "../../hooks/useProject";
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";
import { Link } from "react-router-dom";
import Flower from '../../components/common/Flower/Flower';
import ClickFlower from '../../components/common/ClickFlower/ClickFlower';
import { IoIosArrowBack } from "react-icons/io";
import { FaCheck } from "react-icons/fa";
import '../../styles/ProjectList.css';

export default function ProjectDetails(){
  
  const formatData = (date) => {
      if(!date) return "";
      return new Date(date).toISOString().split("T")[0];
  };
    const {index, project, updateProject} = useProject();
    const navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [words, setWords] = useState("");
    const [finishdate, setFinish] = useState(formatData(""));
    const [cover, setCover] = useState(null);

    useEffect(() => {
        if (!project) return;
        setTitle(project.title);
        setDescription(project.description);
        setWords(project.words);
        setFinish(formatData(project.finishDate));
        setCover(project.cover);
      }, [project]);

    if(!project) return ( <div> 
          <h2> Projekt nie istnieje </h2>
          <button onClick={() => navigate('/')}>Wróć do listy</button> </div> );
    
    const EditProject= async (e)=>{
        e.preventDefault();
        const updatedProject = { 
        ...project, 
        title, 
        description, 
        words, 
        finishDate: finishdate, 
        cover 
      };
        
        updateProject(updatedProject);
        navigate(`/offline/project/${index}`);

    }


    return (
       <div className="projectlist-wrapper">

          <ProjectHeader
              headerTitle={"Edytuj projekt"}
              showBackButton={true}
              path={`/offline/project/${index}`}
          />
          <div className="SettingsForm" style={{marginTop: '100px'}}> 
            <form onSubmit={EditProject}>

                <label>
                  Tytuł projektu
                  <input type="text" name="title" value={title} onChange={(e) => setTitle(e.target.value)} className="chapterInput" />
                </label>

                <label>
                  Opis
                  <textarea name="description" value={description} onChange={(e) => setDescription(e.target.value) } className="chapterInput" />
                </label>

                <label>
                  Liczba słów
                  <input type="number" name="words" value={words} onChange={(e) => setWords(e.target.value) } className="chapterInput" />
                </label>

                <label>
                  Kiedy chcesz skończyć
                  <input type="date" name="finishDate" value={finishdate} onChange={(e) => setFinish(e.target.value) } className="chapterInput" />
                </label>
                <label>
                {cover && (
                    <img
                        src={cover}
                        alt="Okładka projektu"
                        style={{ width: "80px", borderRadius: "8px", marginBottom: "10px" }}
                    />
                )}
                  Okładka
                  <input type="file" accept="image/*" name="cover" onChange={async (e) => {
                    let CoverEdit = e.target.files[0];
                    CoverEdit = await toBase64(CoverEdit);
                    setCover(CoverEdit);
                    }}  />
                </label>
                <div className="buttons-row">
                    <button onClick={()=>navigate(`/offline/project/${index}`)}> <FaCheck/> Zatwierdź zmiany </button>
                </div>

        </form>


          </div>
        <Link to={`/local/project/${index}/setting`} className="BackfixButton"><IoIosArrowBack /></Link>
        <Flower
          flowerClass={"flower1"}/>
        <Flower
          flowerClass={"flower2"}/>
        <ClickFlower/>
    </div>
    )
}